<script setup>
import { computed } from 'vue';
import CarRentalFields from './fields/CarRentalFields.vue';
import FlightFields from './fields/FlightFields.vue';
import HotelFields from './fields/HotelFields.vue';
import PackageFields from './fields/PackageFields.vue';
import OtherFields from './fields/OtherFields.vue';

const props = defineProps({
  bookingType: { type: String, required: true },
  modelValue: { type: Object, default: () => ({}) },
  errors: { type: Object, default: () => ({}) },
});

defineEmits(['update:modelValue']);

const FIELDS = {
  car_rental: CarRentalFields,
  flight: FlightFields,
  hotel: HotelFields,
  package: PackageFields,
  other: OtherFields,
};

const fieldsComponent = computed(() => FIELDS[props.bookingType] || null);
</script>

<template>
  <component
    :is="fieldsComponent"
    v-if="fieldsComponent"
    :model-value="modelValue"
    :errors="errors"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
